import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { group }: Boundaries["editResourceGroup"]["request"],
): State {
  const index = state.findIndex((req) => req.group.uuid === group.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { group, requestState: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { group, requestState: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  group: Boundaries["editResourceGroup"]["success"],
): State {
  const index = state.findIndex((req) => req.group.uuid === group.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { group, requestState: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { group, requestState: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { group }: Boundaries["editResourceGroup"]["failure"],
): State {
  const index = state.findIndex((req) => req.group.uuid === group.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { group, requestState: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { group, requestState: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editResourceGroupRequested]: handleRequest,
    [events.editResourceGroupSucceeded]: handleSuccess,
    [events.editResourceGroupFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
